import { getTOUVersionMaster, getUser } from "@app/api";
import { Helmet, NavigationItem, PageTitle } from "@app/components/atoms";
import { clearMachineReportsPreferences } from "@app/helpers";
import { DescriptionOutlined } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const PrivacyPolicyHeaderTitles = [
  {
    title: "country",
    width: 250,
  },
  {
    title: "link",
    width: 550,
  },
  {
    title: "versionNew",
    width: 120,
  },
  {
    title: "countryCode",
    width: 120,
  },
];

export function PrivacyPolicy() {
  const { t } = useTranslation();
  const [privacyPolicyData, setPrivacyPolicyData] = useState<any>(null);
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const getUserAPI = await getUser();
        if (!getUserAPI || !getUserAPI?.data?.data) {
          throw new Error("Failed to fetch user data");
        }

        let { residenceCountryCode } = getUserAPI?.data?.data;

        if (!residenceCountryCode) {
          throw new Error("Residence country code is missing");
        }
        const getTOUVersionMasterAPI = await getTOUVersionMaster(
          residenceCountryCode
        );
        if (
          !getTOUVersionMasterAPI ||
          !getTOUVersionMasterAPI?.data?.data ||
          getTOUVersionMasterAPI?.data?.data.length === 0
        ) {
          console.warn(
            "No data received from getTOUVersionMaster API, stopping execution."
          );
          return;
        }

        const privacyPolicyData = getTOUVersionMasterAPI?.data?.data?.find(
          (item: { type: any }) => item.type === "PRIVACY_POLICY"
        );
        if (privacyPolicyData) {
          setPrivacyPolicyData(privacyPolicyData);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  const countryNames: Record<string, string> = {
    BR: "Brazil",
    CL: "Chile",
    CO: "Colombia",
    EG: "Egypt",
    JP: "Japan",
    PH: "Phillipine",
    SA: "Kingdom of Saudi Arabia",
    AE: "United Arab Emirates (UAE)",
    O: "Others",
  };
  useEffect(() => {
    clearMachineReportsPreferences();
  }, []);
  return (
    <div className="group-list-page license">
      <Helmet title={t("metaInfo.privacyPolicy")} />
      <div className="container">
        <div className="row">
          <div className="sp-p24">
            <NavigationItem title={t("license.backToHome")} />
            <PageTitle title={t("privacyPolicy")} className="mt-24 mb-25">
              <DescriptionOutlined />
            </PageTitle>
          </div>
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  {PrivacyPolicyHeaderTitles.map((key, index) => (
                    <th key={index} style={{ minWidth: key?.width }}>
                      {t(`license.${key?.title}`)}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {privacyPolicyData ? (
                  <tr>
                    <td>
                      {countryNames[privacyPolicyData.residenceCountryCode] ||
                        "Unknown"}
                    </td>
                    <td>
                      <a
                        href={privacyPolicyData.pdfUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                          color: "#551a8b",
                          textDecoration: "underline",
                        }}
                      >
                        {privacyPolicyData.pdfUrl}
                      </a>
                    </td>
                    <td>{privacyPolicyData.version}</td>
                    <td>{privacyPolicyData.residenceCountryCode}</td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan={3} style={{ textAlign: "center" }}>
                      {t("privacyPolicynodata")}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
